/**
 * Форма создания пользователя с ролью "Менеджер"
 */

import React from 'react';
import { Formik, Form } from 'formik';
import { TextInput } from '@components/UI/FormItems';
import { useCreateUserManager } from '@/hooks/useAdmin.ts';
import { createUserSchema } from '../validation/schemas';
import type { CreateUserForm as CreateUserFormValues } from '../../../types';

/**
 * Компонент формы создания пользователя
 */
export const CreateUserFormComponent: React.FC = () => {
  const createUserMutation = useCreateUserManager();

  const initialValues: CreateUserFormValues = {
    login: '',
    password: '',
    comment: '',
  };

  const handleSubmit = async (values: CreateUserFormValues, { resetForm }: any) => {
    await createUserMutation.mutateAsync(values);
    resetForm();
  };

  return (
    <fieldset>
      <Formik
        initialValues={initialValues}
        validationSchema={createUserSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <div style={{ display: 'table' }}>
              <div style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                Добавить пользователя с ролью &quot;MANAGER&quot;
              </div>
              <div style={{ marginTop: '20px' }} />

              <TextInput label="Логин: " name="login" placeholder="Введите логин" />

              <TextInput
                label="Пароль: "
                name="password"
                type="password"
                placeholder="Минимум 8 символов"
              />

              <TextInput
                label="Комментарий: "
                name="comment"
                placeholder="Необязательное поле"
              />

              <button
                className="btn"
                type="submit"
                disabled={createUserMutation.isPending}
                style={{ marginLeft: '10px' }}
              >
                {createUserMutation.isPending ? 'Создание...' : 'Создать пользователя'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </fieldset>
  );
};
